import Vue from 'vue';
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import browser from 'browser-detect';
import demoSite from '@/live-demo/demo-site.json';
import NotificationsContainer from './notifications';
import FetchOrigin from './fetch-origin';

// This component runs in both admin panel and editor
export default Vue.component('global-view', {
  template: require('./template.html'),
  name: 'global-view',
  components: {
    NotificationsContainer,
    FetchOrigin,
  },
  data() {
    return {
      assets: process.env.S3_ASSETS_URL,
      contentLoaded: false,
      fullScreen: false,
      offlineMsg: 'You are currently offline. Some features may not be available until you reconnect.',
      onlineMsg: 'Connected!',
    };
  },
  watch: {
    $route(to, from) {
      if (!this.$demo) {
        // store the last route in localStorage
        const previousRoute = window.localStorage.getItem('lastRoute');
        if (
          !this.$route.path.match(/splash/gi) &&
          to.path !== '/' &&
          !this.$route.path.match(/signup/gi) &&
          !this.$route.path.match(/storm/) &&
          !this.$route.path.match(/blocked/gi)
        ) {
          window.localStorage.setItem('lastRoute', _.clone(to.path));
        }
        if (this.$route.path.match(/storm/)) {
          window.localStorage.setItem('lastStormRoute', _.clone(to.path));
        }
        if (previousRoute !== to.path && to.path !== '/splash' && to.path !== '/storm') {
          this._trackEvent({
            type: 'route_change',
            meta: {
              to: to.path,
              from: from.path,
            },
          });
        }
      }
    },
  },
  created() {
    if (!this.$demo) {
      // here we load save pasted urls so users can link tickets etc
      // and load them in storm
      const { pathname } = window.location;
      if (this._storm && pathname.match(/^\/storm/gi)) {
        window.localStorage.setItem('lastStormRoute', pathname);
      }
      // we need to grab our user pool right off the bat
      const userPool = new CognitoUserPool({
        UserPoolId: process.env.COGNITO_USERPOOL_ID,
        ClientId: process.env.COGNITO_CLIENT_ID,
      });
      this.$store.dispatch('setUserPool', userPool);
      this.$router.push({ path: '/splash' });
      // setup online / offline listeners so user's can know about it
      window.removeEventListener('online', this.updateOnlineStatus);
      window.addEventListener('online', this.updateOnlineStatus);
      window.removeEventListener('offline', this.updateOnlineStatus);
      window.addEventListener('offline', this.updateOnlineStatus);
      if (!navigator.onLine) {
        this.updateOnlineStatus({ type: 'offline' });
      }
      this.$store.dispatch('setBrowser', browser());
    }

    if (this.$demo) {
      this.setDemo();
    }
  },
  computed: {
    ...mapGetters([
      'currentSite',
      'websites',
      'siteBuilt',
      'currentPage',
      'currentUser',
      'identityId',
      'online',
    ]),
  },
  methods: {
    async checkLoggedIn() {
      const loggedIn = await this.$store.dispatch('login');
      if (!loggedIn) {
        this.$router.push({ path: '/' });
      }
    },
    setDemo() {
      this.$store.dispatch('setCurrentSite', demoSite);
      this.$router.push({ path: '/edit-page/demo-page' });
    },
    updateOnlineStatus(params) {
      const type = params.type;
      const payload = {
        id: this.guid(),
      };
      if (type === 'offline' && this.online) {
        // update to offline
        payload.online = false;
        payload.message = this.offlineMsg;
        this.$store.dispatch('updateOnlineStatus', payload);
      } else if (type === 'online' && !this.online) {
        // update to online
        payload.online = true;
        payload.message = this.onlineMsg;
        this.$store.dispatch('updateOnlineStatus', payload);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/index.js